import {
	CognitoUser,
	CognitoUserPool,
	CognitoUserSession,
} from 'amazon-cognito-identity-js';

import UniversalCookie from 'universal-cookie';

interface ISessionResult { session: CognitoUserSession | null; err: Error | null; }

const cookies = new UniversalCookie();

const useSessionCookies = () => {
	const readCookies = () => {
		const username = cookies.get('username');
		const refreshToken = cookies.get('refreshToken');

		if (username && refreshToken) {
			return {
				refreshToken,
				username,
			};
		}

		return undefined;
	};

	const clearCookies = () => {
		cookies.remove('username');
		cookies.remove('refreshToken');
	};

	type RefreshSession = (args: {
		username: string;
		refreshToken: string;
	}) => Promise<CognitoUserSession>;

	const refreshSession: RefreshSession = async ({ refreshToken, username }) => {

		const poolData = {
			UserPoolId: process.env.COGNITO_USER_POOL_ID ?? '',
			ClientId: process.env.COGNITO_CLIENT_ID ?? '',
		};

		const appPoolData = {
			UserPoolId: process.env.COGNITO_USER_POOL_ID ?? '',
			ClientId: process.env.COGNITO_APP_CLIENT_ID ?? '',
		};

		// Cognito is expecting a function that returns the refresh token.
		// Since we're pulling the actual token from the cookie, we need to
		// wrap it in a function that returns the token...
		const handleRefreshToken = { getToken: () => refreshToken };

		const userPool = new CognitoUserPool(poolData);
		const appUserPool = new CognitoUserPool(appPoolData);

		const cognitoUser = new CognitoUser({
			Username: username,
			Pool: userPool,
		});

		const appCognitoUser = new CognitoUser({
			Username: username,
			Pool: appUserPool,
		});

		const handleSessionRequest = (resolve: (value: unknown) => void) => (err: any, session: CognitoUserSession) => {
			resolve({ session, err });
		};

		const defaultPool: ISessionResult = await new Promise((resolve) => cognitoUser.refreshSession(
			handleRefreshToken,
			handleSessionRequest(resolve)
		));

		if (defaultPool.session)
			return defaultPool.session;

		const appPool: ISessionResult = await new Promise((resolve) => appCognitoUser.refreshSession(
			handleRefreshToken,
			handleSessionRequest(resolve)));

		if (appPool.session)
			return appPool.session;

		throw defaultPool.err;

	};

	return {
		readCookies,
		clearCookies,
		refreshSession,
	};
};

export default useSessionCookies;
